import React from 'react';
import PropTypes from 'prop-types';
import { safeRest } from '@wds/utils';
import { CSSTransition } from 'react-transition-group';

import {
  MOTION_DISTANCES,
  MOTION_SPEEDS,
  MOTION_DIRECTIONS,
  SLIDE,
} from '@wds/helpers';
import useStyles from './useStyles';

const Slide = ({ children, timeout, direction, speed, distance, ...rest }) => {
  const slideSpeed = timeout || SLIDE.speed[speed];
  const slideDistance = SLIDE.distance[distance];
  const classes = useStyles({
    slideSpeed,
    direction,
    slideDistance,
  });
  return (
    <CSSTransition
      className={classes.wdsSlide}
      classNames={{ ...classes }}
      timeout={slideSpeed}
      unmountOnExit
      {...safeRest(rest)}
    >
      {children}
    </CSSTransition>
  );
};

Slide.propTypes = {
  /**
   * The component to wrap the transition around
   */
  children: PropTypes.node.isRequired,
  /**
   * Motion direction variants
   */
  direction: PropTypes.oneOf(MOTION_DIRECTIONS),
  /**
   * Set timeout delay of transition
   */
  timeout: PropTypes.number,
  /**
   * Motion speed variants
   */
  speed: PropTypes.oneOf(MOTION_SPEEDS),
  /**
   * Motion distance variants
   */
  distance: PropTypes.oneOf(MOTION_DISTANCES),
};

Slide.defaultProps = {
  direction: 'up',
  speed: 'normal',
  distance: 'normal',
  timeout: undefined,
};

export default Slide;
